import React from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { Column, Row } from 'react-foundation';
import { Link } from 'react-router-dom';
import { formatMsisdn } from '../../utils/helpers';
import { Products, Product } from '../../model/Products';
import { useApiQuery } from '../../utils/apiHooks';
import { ApiRequest } from '../../utils/api';
import { OfferingType } from '../../utils/offeringType';

interface Props {
	nonActivatedSims: any[];
	offeringType: OfferingType;
}

const SimListWrapper = styled.div`
	width: 100%;
	margin: auto;
	font-size: 1em;
	color: gray;
	.unmapped-sim {
		color: #979797;
	}
	span {
		text-align: left;
		color: gray;
		font-size: 1em;
		margin-top: 0.7em;
		display: inline-block;
		height: 2.5em;
		overflow-wrap: break-word;
	}
	h4 {
		text-align: center;
	}
	.mapped-sim {
		color: red;
	}
	.no-padding {
		padding-left: 0;
		padding-right: 0;
	}
	.sim-name {
		word-break: break-word;
		overflow-wrap: break-word;
	}
`;

const SimRow = styled.div<{ index: number }>`
	${(props) => (props.index === 0 ? 'border-top: 1px solid #eaeaea;' : '')}
	border-bottom: 1px solid #eaeaea;
	min-height: 3em;
	overflow: auto;
	display: flex;
	flex-direction: column;
`;

const ActivateSimsHeader = styled.h4`
	color: red;
`;

const getPackageType = (packageType: string, products: Products | undefined) => {
	if (products === undefined) {
		return null;
	}
	return products.productPackagePrices.find((product: Product) => packageType === product.orderItemCode);
};

interface ListRowProps {
	sim: any;
	index: number;
	productPackageType: any;
}

const ListRow: React.FC<ListRowProps> = (props: ListRowProps) => (
	<Row key={props.index}>
		<SimRow index={props.index}>
			<div>
				<Column large={3}>
					<span className={'sim-name'}>{props.sim.name}</span>
				</Column>
				<Column large={2}>
					<span>{formatMsisdn(props.sim.msisdn)}</span>
				</Column>
				<Column large={3}>{!_.isNil(props.productPackageType) && <span>{props.productPackageType.displayName}</span>}</Column>
				<Column large={4}>
					{props.sim.simMapped && !props.sim.mnpInfoMissing && props.sim.needsActivation && (
						<Link
							to={{
								pathname: '/account/activateSubscription',
								state: {
									id: props.sim.id,
									name: props.sim.name,
									msisdn: props.sim.msisdn,
									subscriptionNumber: props.sim.subscriptionNumber
								}
							}}
						>
							<span className={'mapped-sim'}>Ota liittymä käyttöön</span>
						</Link>
					)}
					{!props.sim.simMapped && <span>SIM-korttia toimitetaan</span>}
					{props.sim.simMapped && props.sim.mnpInfoMissing && <span>Numeronsiirron lisätiedot vaaditaan</span>}
					{props.sim.simMapped && !props.sim.mnpInfoMissing && props.sim.isMnpPending && !props.sim.needsActivation && (
						<span>{`Numero siirtyy ja aktivoituu automaattisesti ${props.sim.mnpActivationDateTime !== null ? props.sim.mnpActivationDateTime : ''}`}</span>
					)}
					{props.sim.simMapped && !props.sim.mnpInfoMissing && !props.sim.isMnpPending && !props.sim.needsActivation && <span>Liittymää käsitellään</span>}
				</Column>
			</div>
		</SimRow>
	</Row>
);

export const NonActivatedSimsList: React.FC<Props> = (props: Props) => {
	const { data: products } = useApiQuery(ApiRequest.getProducts(props.offeringType), { cacheTime: 60000 });

	return (
		<SimListWrapper>
			<ActivateSimsHeader>Ota uusi liittymäsi käyttöön</ActivateSimsHeader>
			{props.nonActivatedSims.map((sim: any, index: number) => (
				<ListRow sim={sim} key={index} index={index} productPackageType={getPackageType(sim.productPackageType, products)} />
			))}
		</SimListWrapper>
	);
};
